import Input from "../../material/input/Input";
import Select from "../../material/select/Select";

const LicenseRegistration = ({ medicalType, setMedicalType, licenseNumber, setLicenseNumber, placeholderType, placeholderLicense, labelType, labelLicense }) => {
    let medicalTypeList = [
    {
      key: "แพทยสภา",
      value: "แพทยสภา",
    },
    {
      key: "สภาเทคนิคการแพทย์",
      value: "สภาเทคนิคการแพทย์",
    },
    {
      key: "สภาเภสัชกรรม",
      value: "สภาเภสัชกรรม",
    },
    {
      key: "ทันตแพทยสภา",
      value: "ทันตแพทยสภา",
    },
  ];

  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <div className="grid grid-cols-2 md:grid-cols-1 gap-4">
        <Select
          placeholder={placeholderType}
          label={labelType}
          value={medicalType}
          setValue={setMedicalType}
          list={medicalTypeList}
        />

        <Input
          label={placeholderLicense}
          placeholder={labelLicense}
          value={licenseNumber}
          setValue={setLicenseNumber}
        ></Input>
      </div>
    </div>
  );
};

export default LicenseRegistration;
